import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useTranslation } from "react-i18next";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, MARKETING_LINKS } from "./constants";

export default function HomeFooter() {
  const { t } = useTranslation(["pages", "common"]);

  return (
    <footer className="border-t border-gray-800 bg-gray-950 text-white">
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-4 px-6 py-7 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-x-8">
        <div className="flex flex-col gap-1.5">
          <Link
            to="/"
            className="flex items-center gap-2.5 text-[15px] font-bold tracking-[-0.02em]"
          >
            <span
              aria-hidden="true"
              className="inline-block h-2.5 w-2.5 -skew-x-12 rounded-[2px] bg-primary-500"
            />
            Race Manager
          </Link>
          <span className="text-xs text-gray-500">
            {t("pages:home.footer.copyright", {
              year: new Date().getFullYear(),
            })}
          </span>
        </div>

        <ul className="flex flex-wrap gap-x-6 gap-y-2 text-[13.5px] text-gray-400">
          {MARKETING_LINKS.map((link) => (
            <li key={link.to}>
              <Link to={link.to} className="transition-colors hover:text-white">
                {t(link.labelKey)}
              </Link>
            </li>
          ))}
          <li>
            <Link to="/login" className="transition-colors hover:text-white">
              {t("pages:home.signIn")}
            </Link>
          </li>
        </ul>

        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-gray-400 transition-colors hover:text-white"
        >
          <Instagram className="h-4 w-4" aria-hidden="true" />
          <span className="sr-only">{t("pages:home.footer.instagram")} </span>
          <span className="font-mono text-[12.5px]">{INSTAGRAM_HANDLE}</span>
        </a>
      </div>
    </footer>
  );
}
